module.exports = __webpack_public_path__ + "static/img/金税一言banner.1581cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/金税一言banner.png
// module id = uRpl
// module chunks = 34